define('formkit/view/form.object/common/design.general.view',['require','exports','module','underscore','uikit/uikit','../../../templates','bluebird','redactor/redactor','../data.label.selector.view'],function(require, exports, module) {
  //prettier-ignore
  var _                     = require('underscore'),
      UIKit                 = require('uikit/uikit'),
      Templates             = require('../../../templates'),
      Promise               = require('bluebird'),
      Redactor              = require('redactor/redactor'),
      DataLabelSelectorView = require('../data.label.selector.view');

  var DesignAnswerView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="formView" />';
    },

    internalViews: {
      descriptionView: Redactor.RedactorView.extend({
        options: _.extend({}, Redactor.RedactorView.prototype.options, {
          buttons: ['bold', 'underline', 'italic', 'deleted', 'lists', 'link'],
        }),
      }),
      numberLabelView: UIKit.Input,
      titleView: UIKit.Input,
    },

    internalViewOptions: {
      formView: function() {
        return {
          type: UIKit.Form,
          model: this.model,
        };
      },
      requiredQuestionView: function() {
        return {
          type: UIKit.Checkbox,
          checkboxId: 'requiredQuestionCheckbox',
          model: this.model,
          value: this.model.get('required'),
          disabled: this.form.isAlwaysRequired(this.model),
          bindings: {
            value: 'required',
          },
        };
      },
      dataLabelView: function() {
        return {
          type: DataLabelSelectorView,
          childViewOptions: {
            bindings: {
              text: 'value'
            }
          },
          form: this.form,
          model: this.model,
        }
      },
      descriptionView: function() {
        return this.getFormViewComponentOptionsByProperty('description');
      },
      numberLabelView: function() {
        return this.getFormViewComponentOptionsByProperty('label');
      },
      titleView: function() {
        return this.getFormViewComponentOptionsByProperty('text');
      },
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);

      this.on('formView:after:render:all', function() {
        var templateObjectModel = this.model;

        this.setAlwaysRequired(templateObjectModel)
      });

      // TODO: the event below does not seem to work as the event never appears to fire.  Safe to remove???
      this.listenTo(this.form, 'before:attach:templateObject', function(templateObjectModel, parent) {
        var templateObjectTypeName = this.form.getTemplateObjectTypeName(templateObjectModel);
        if (this.form.isAlwaysRequired(templateObjectModel)) {
          templateObjectModel.set('required', true);
          this.form.util.insertRequiredRule(templateObjectModel);
        }
      });
    },

    getCustomValidationRule: function() {
      return this.getOption('customValidationRule') || false;
    },

    setAlwaysRequired: function(templateObjectModel) {
      if (this.form.isAlwaysRequired(templateObjectModel)) {
        templateObjectModel.set('required', true);
        this.form.util.insertValidationRule(this.model, this.getCustomValidationRule() );
      }

      return this;
    },

    onFirstRender: function() {
      this.listenTo(
        this.requiredQuestionView,
        'change:value',
        _.debounce(function() {
          this.form.util.insertValidationRule(this.model, this.getCustomValidationRule());
        })
      );
    },

    getFormViewComponentOptionsByProperty: function(property) {
      return {
        model: this.model,
        bindings: this.getBindingsFromModelAttributeMap(property),
      };
    },

    getBindingsFromModelAttributeMap: function(property) {
      return {
        value: this.getOption('modelAttributeMap') ? this.getOption('modelAttributeMap')[property] : property,
      };
    },

    attachNumberDataLabelAndRequiredRow: function() {
      var isSectionHeader = this.getOption('disableLabelAndDescriptionInputFields');
      var isInformationTemplateTypeObject = this.model.get('type.description') === 'Information';
      var useDataLabels = this.form.localConfig ? this.form.localConfig.get('formkit.useDataLabels') : false;
      var dataLabelWidth = this.model.get('type.isTargetable') ? 12 : 14;  // only targetable fields can be requrired

      if (useDataLabels && !isSectionHeader && !isInformationTemplateTypeObject) {
        this.formView
          .addGroup()
          .addField(
            { text: 'No.', width: 2 },
            this.buildComponent({ name: 'numberLabelView' })
          )
          .parent()
          .addField(
            { text: 'Label', required: true, width: dataLabelWidth },
            this.buildComponent({ name: 'dataLabelView', placeholder: 'Select or add new...', collection: this.model.getDataLabelsCollection() })
          )
          .parent()
          .addField(
            { text: 'Required', width: 2, visible: this.model.get('type.isTargetable')  },
            this.requiredQuestionView = this.buildComponent({ name: 'requiredQuestionView' })
          )
          .parent()
          .parent();
      }
    },

    attachTitleViewRow: function() {
      var useDataLabels                   = this.form.localConfig ? this.form.localConfig.get('formkit.useDataLabels') : false;
      var isSectionHeader                 = this.getOption('disableLabelAndDescriptionInputFields');
      var isInformationTemplateTypeObject = this.model.get('type.description') === 'Information';
      var canBeRequired                   = this.model.get('type.isTargetable')
      var titleWidth                      = isInformationTemplateTypeObject ? 14 :
                                              isSectionHeader ? 16 :
                                              canBeRequired && !useDataLabels ? 12 :
                                              !canBeRequired && !useDataLabels ? 14 : 16;
      var titleText                       = isSectionHeader ? 'Section Title' :
                                              isInformationTemplateTypeObject ? 'Information Title' : 'Question';
      var titlePlaceholderText            = isSectionHeader ? 'Enter your section title' :
                                              isInformationTemplateTypeObject ? 'Enter your title' : 'Write your question';

      var formView = this.formView.addGroup();

      if (!isSectionHeader && (isInformationTemplateTypeObject || !useDataLabels)) {
        formView.addField(
          { text: 'No.', width: 2 },
          this.buildComponent({ name: 'numberLabelView' })
        )
        .parent();
      }

      formView.addField(
        { text: titleText, width: titleWidth },
        this.buildComponent({ name: 'titleView', placeholder: titlePlaceholderText })
      )
      .parent();

      if (canBeRequired && !isSectionHeader && !isInformationTemplateTypeObject && !useDataLabels) {
        formView.addField(
          { text: 'Required', width: 2 },
          this.requiredQuestionView = this.buildComponent({ name: 'requiredQuestionView' })
        )
        .parent()
      }

      formView.parent();
    },

    attachDescriptionRow: function() {
      var isSectionHeader = this.getOption('disableLabelAndDescriptionInputFields');

      if (!isSectionHeader) {
        this.formView
          .addGroup()
          .addField(
            { text: 'Description', width: 16 },
            this.buildComponent({
              name: 'descriptionView',
              placeholder: 'Write your description',
            })
          );
      }
    },

    onInjectedFormView: function() {
      this.attachNumberDataLabelAndRequiredRow();
      this.attachTitleViewRow();
      this.attachDescriptionRow();
    },
  });

  module.exports = DesignAnswerView;
});

